import React, { useEffect, useContext } from 'react';
//import logo from './logo.svg';
import './App.css';
import {BrowserRouter as Router, Route, Routes, useNavigate} from "react-router-dom";
import { AuthProvider, AuthContext } from './context/AuthContext';

import Login from './components/LoginForm'; // Ujistěte se, že cesta je správná
import Register from './components/RegisterForm'; // Ujistěte se, že cesta je správná
import ValidateRegistrationPage from './components/ValidateRegistrationPage'; // Ujistěte se, že cesta je správná
import Dashboard from './pages/Dashboard'; // Ujistěte se, že cesta je správná
import Apps from './pages/Apps';
import PrivateRoute from './components/PrivateRoute';
//Parametry
import Param from './pages/Param'; // Ujistěte se, že cesta je správná
//energie
import Energie from './pages/Energie';
import EnergieEntita from './pages/EnergieEntita';
import EnergieEntitaGrafRok from './pages/EnergieEntitaGrafRok';
import EnergieDataObdEntity from './pages/EnergieDataObdEntity';
import EnergieDataDenEntity from './pages/EnergieDataDenEntity';
//zdravi
import Zdravi from './pages/Zdravi';



const Root = () => {
  const { isAuthenticated } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard');
    }
  }, [isAuthenticated, navigate]);

  return <Login />;
};

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Root />} />
          <Route path="/register" element={<Register />} />
          <Route path="/ValidateRegistration" element={<ValidateRegistrationPage />} />
          <Route path="/dashboard" element={<PrivateRoute />}>
            <Route path="/dashboard" element={<Dashboard />} />
          </Route>
          <Route path="/apps" element={<Apps />} />
          
          <Route path="/Param" element={<Param />} />
          
          <Route path="/EnergieEntitaGrafRok" element={<EnergieEntitaGrafRok />} />
          <Route path="/EnergieDataObdEntity" element={<EnergieDataObdEntity />} />
          <Route path="/EnergieDataDenEntity" element={<EnergieDataDenEntity />} />
          <Route path="/EnergieEntita" element={<EnergieEntita />} />
          <Route path="/Energie" element={<Energie />} />
          
          <Route path="/Zdravi" element={<Zdravi />} />
          
          

        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
